import JtlApiClient from "./base";

export const InboundMonitoringApi = {
  // Fetch ritual outlets status
  getCronStatus: () => {
    return JtlApiClient.get("/jtl/cron/status");
  },

  startCronMonitor: (schedule) => {
    // Both are query parameters in the python function definition
    return JtlApiClient.post("/jtl/cron/start", null, {
      params: {
        schedule,
      },
    });
  },

  stopCronMonitor: () => {
    return JtlApiClient.post("/jtl/cron/stop");
  },
};

export const JtlApi = {
  run_check: (startDate, endDate, delivery_time_add) => {
    return JtlApiClient.post(`/jtl/run-check/`, {
      start_date: parseDate(startDate),
      end_date: parseDate(endDate),
      delivery_time_add: delivery_time_add,
    });
  },

  // Download evaluation result file by filename
  download_eval_file: (filename) => {
    return JtlApiClient.get(`/jtl/eval/download/${filename}`, {
      responseType: "blob",
    });
  },

  list_eval_files: () => {
    return JtlApiClient.get("/jtl/eval/list");
  },

  create_inbounds: (date, user_id, token) => {
    return JtlApiClient.post("/jtl/create-inbounds/", {
      date: date,
      user_id: user_id,
      token: token,
    });
  },
};
